// extracted by mini-css-extract-plugin
module.exports = {"container":"list-module--container--JZ5YH"};